module.exports = __webpack_public_path__ + "img/custom.73e585f1.svg";